module.exports = __webpack_public_path__ + "img/account-choose-icon.03044bbb.svg";